const unauthorized = (api) => {
    api.interceptors.request.use((config) => config);

    api.interceptors.response.use((response) => response,
        (error) => {
            if (error.response.status === 401) {
                localStorage.removeItem("token");
                window.dispatchEvent(new Event('auth-token-removed'));
            };

            return Promise.reject(error);
        });
};

export default unauthorized;